<template>  
  <div class="bawOrderDetailPage">
    <XR-head titleText="订单详情"></XR-head>
    <div class="order-state" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="state-text">{{orderDetail.StateName}}</p>
    </div>
    <!--
    <router-link :to="'/usercenter/candyOrderDelivery?orderNo='+orderDetail.OrderNo" class="" v-if="orderDetail.DeliveryTracking && orderDetail.DeliveryTracking[0].WuLiu">
      <div class="delivery" v-if="!loaded">
        <div class="leftIcon">
          <i class="fa fa-delivery"></i>
        </div>
        <div class="delivery-process">
          <div class="text">{{ orderDetail.DeliveryTracking[0].WuLiu.data.length>0?orderDetail.DeliveryTracking[0].WuLiu.data[0].context : orderDetail.DeliveryTracking[0].WuLiu.message}}</div>
        </div>
        <div class="rightIcon">
          <i class="fa fa-angle-right"></i>
        </div>
      </div>
    </router-link>
    -->
    <div style="background: white; padding:10px;" v-if="!loaded">
      <div style="margin-top:10px;background: white;line-height: 16px;font-size: 12px;">{{orderDetail.DeliveryTracking[0].LogisticsCompanyIdName}}</div>
      <div style="margin-top:10px;background: white;line-height: 16px;font-size: 12px;">运单号：{{orderDetail.DeliveryTracking[0].DeliveryNo}}</div>
    </div>
    
    <!-- <router-link :to="'/usercenter/candyOrderDelivery?orderNo='+orderDetail.OrderNo" class="" v-if="orderDetail.DeliveryTracking"> -->
    <div class="receive-address">    
      <span style="line-height: 40px;font-weight: bold;" v-if="!baworderdetail.Receiver">请选择收货地址</span>
      <div class="mapIcon">
        <img src="/static/icon/address-location.png" />
      </div>
      <div class="address-info" :style="{width:addressInfoWidth+'px'}" v-if="baworderdetail.Receiver">         
        <div class="contract">
          <span class="name">{{baworderdetail.Receiver}}</span>
          <span class="mobile">{{baworderdetail.Phone}}</span>              
        </div>
        <div class="address-content">
          <span class="text">{{baworderdetail.Address}}</span>
        </div>
      </div>
    </div>
    <!-- </router-link> -->

    <div class="order-list" v-if="!loaded">
      <div class="order-item">
        <div class="shoptip">
          <img class="shop-logo" :src="orderDetail.ShopLogo" />
          <p class="shop-name">{{orderDetail.ShopName}}</p>
          <p class="state"></p>
        </div>
        <div class="hidden-scorll">
          <div class="suborder-item-list">
            <div class="suborder-item" v-for="orderItem in orderDetail.OrderItems" :key="orderItem.ItemId">              
              <router-link :to="'/'+candyName+'/productDetail?skuId='+orderItem.SkuId">
                <img :src="orderItem.DetailImage?orderItem.DetailImage:IMGServer_URL+'/images/index-item-default.png'" onerror="this.src=IMGServer_URL+'/images/index-item-default.png'" class="order-img" />
                <div class="product-info" :style="{ width:suborderItemProductNameWidth+'px'}">
                  <p class="product-name">{{orderItem.ProductName}}</p>
                  <p class="attr">数量:{{orderItem.Quantity}} {{orderItem.Attribute}}</p>
                  <p class="price">{{orderItem.Baw.toFixed(candyDecimal)}}BAW</p>
                  <router-link class="item-button" :to="'/usercenter/candyOrderEvaluate?itemId='+orderItem.ItemId+'&skuId='+orderItem.SkuId" v-if="orderItem.State==2 && !orderItem.IsComment">评价</router-link>
                </div>   
              </router-link>           
            </div>
          </div>
        </div>
        <div class="order-detail" v-if="!loaded">
          <div class="order-info">
            <div class="field"><span>订单编号：</span>{{orderDetail.OrderNo}}</div>
            <div class="field"><span>下单时间：</span>{{orderDetail.Time.CreateDateName}}</div>
			<div class="field payOverDate" v-if="orderDetail.State ==1"><span> 超时时间  </span><span class="payOverDateTime">{{payOverDateName}}</span></div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>支付方式：</span>BAW</div>
            <div class="field"><span>支付时间：</span>{{orderDetail.Time.PayDateName}}</div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>配送方式：</span>{{orderDetail.OrderDelivery.ShippingMethodName}}</div>
            <div class="field"><span>期望配送日期：</span>{{orderDetail.OrderDelivery.ShippingDateName}}</div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>发票抬头：</span>{{orderDetail.InvoiceHead}}</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="order-detail" v-if="!loaded">  
      <div class="order-info">
        <div class="field">
          <span class="title">商品总额</span>
          <span class="num">{{orderDetail.OrderMoney.TotalBaw.toFixed(candyDecimal)}}BAW</span>
        </div>
        <div class="field">
          <span class="title">运费</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.OrderMoney.FreightMoney.toFixed(2)}}</span>
        </div>
        <div class="summary">
          <span class="title">实付款:</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.OrderMoney.CashMoney.toFixed(2)}}</span>
        </div>
      </div>
    </div>
    <div class="operator" v-if="!loaded && (orderDetail.State == 1 || orderDetail.State == 3 || orderDetail.State==5 || orderDetail.State==6)">
      <div class="button-list">
        <router-link :to="'/baw/orderPay?orderNo='+orderDetail.OrderNo" v-if="orderDetail.State == 1">
          <mu-raised-button label="付款" style="background-color:red;float:right;" class="button-item gobuy" primary></mu-raised-button>
        </router-link>
        <mu-raised-button label="取消订单" @click="orderCancel(orderDetail.OrderNo)" class="orderBtn button-item receive" style="background-color:#7C838B;color:#F2F2F3;float:right;" v-if="orderDetail.State ==1"></mu-raised-button> 
        <!-- <mu-raised-button label="再次购买" primary></mu-raised-button> -->
        <mu-raised-button label="确认收货" class="button-item" @click="orderConfrim" primary v-if="orderDetail.State==5 || orderDetail.State==6"></mu-raised-button>
        <mu-raised-button label="修改地址" style="width:50%;background-color:red;" class="button-item" :to="'/usercenter/candyordermodifyaddress?orderNo='+orderDetail.OrderNo" primary v-if="orderDetail.State==3"></mu-raised-button>
      </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-105),
      loaded:true,
      orderDetail:{},
	  payOverDateName:'',
      baworderdetail:{},
      siteConfig:{ MobileBgImage : '' }
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getSiteInfo()
    this.getOrderDetail()
  },
  methods: {
    getSiteInfo: function () {    
        const ths = this;
        this.$post('/Shop/SiteConfigServer/GetSiteConfig')
            .then(function (res) {
            if(res.IsSuccess){
                ths.siteConfig = res.Data
            }         
        })
        .catch(function (err) {
            console.log(err)
        })    
    },      
    getOrderDetail(){     
      var ths = this;   
      ths.$post(
        "/Shop/" + this.candyName + "Server/Get" + this.candyName + "OrderDetail",
        JSON.stringify({orderno: this.$route.query.orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false
          ths.orderDetail = res.Data
          ths.baworderdetail=res.Data.OrderDelivery
          ths.$refs.XRtoast.hide()
		  if(res.Data.State == 1){
            var serverTime = res.Data.Time.CreateDate.replace('T',' ')
            serverTime = serverTime.replace(new RegExp('-','g'),"/")
            var ts = (new Date(serverTime))-(new Date());
            var overDate = res.Data.Time.PayOverDate.replace('T',' ')
            overDate = overDate.replace(new RegExp('-','g'),"/")
            ths.calcPayOverDate(ts,overDate)
          }
        }
      });
    },
	calcPayOverDate(tmpTs, payOverDate){      
      var ths = this
      var interval = setInterval(function(){
        var ts = (new Date(payOverDate)) - (new Date()) - tmpTs; //计算剩余的毫秒数    
        if (ts <= 0) {
            ths.payOverDateName='已超时'
            clearInterval(interval);
            return;
        }
        var hh = parseInt(ts / 1000 / 60 / 60, 10); //计算剩余的小时数  
        var mm = parseInt(ts / 1000 / 60 % 60, 10); //计算剩余的分钟数  
        var ss = parseInt(ts / 1000 % 60, 10); //计算剩余的秒数 

        if(hh<10){
          hh= '0'+hh
        }
        if(mm<10){
          mm= '0'+mm
        }
        if(ss<10){
          ss= '0'+ss
        }

        ths.payOverDateName = hh+'时'+mm+"分"+ss+'秒' 
      },1000)
    },
    orderConfrim(){      
      var ths = this;   
      ths.$post(
        "/Shop/" + this.candyName + "Server/OrderConfrim",
        JSON.stringify({OrderNos: [this.orderDetail.OrderNo]})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getOrderDetail()
        }
      });
    },  
    orderCancel(orderNo){      
      var ths = this;   
      ths.$post(
        "/Shop/" + this.candyName + "Server/orderCancel",
        JSON.stringify({OrderNo: orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.successCallback(res.Msg, function(){
            ths.getOrderDetail(true)
          })
        }
      });
    },
  }
}
</script>

<style>
#app .bawOrderDetailPage{
  background: #eee;
  padding-bottom: 56px;
}
.bawOrderDetailPage .order-state{
  overflow: hidden;
  line-height: 60px;
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
  color:white;
  padding-left: 15px;

}

.bawOrderDetailPage .delivery {
  overflow: hidden;
  background: white;
  padding:15px 10px;
  margin-top: 10px;
}
.bawOrderDetailPage .delivery .fa{  
  width: 30px;
  margin-top: 4px;
}
.bawOrderDetailPage .delivery .leftIcon {
  float:left;
}
.bawOrderDetailPage .delivery .rightIcon {
  float:right;
  text-align: center;
  margin-top: -23px;
}
.bawOrderDetailPage .delivery .delivery-process{
  overflow: hidden;
  padding-right: 40px;
}
.bawOrderDetailPage .delivery-process .text{
  font-size: 12px;
  color:#999;
  line-height: 16px;
  height: 32px;
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
}

.bawOrderDetailPage .order-delivery {
  overflow: hidden;
  background: white;
  padding:10px;
  margin-top: 10px;
  border-radius: 10px;
}
.bawOrderDetailPage .order-delivery .fa {
  float:left;
  width: 30px;
  margin-top: 4px;
}
.bawOrderDetailPage .order-delivery .delivery-info{
  overflow: hidden;
}
.bawOrderDetailPage .order-delivery .delivery-info .member-info{
  overflow: hidden;
}
.bawOrderDetailPage .order-delivery .member-info .username{
  float: left;
}
.bawOrderDetailPage .order-delivery .member-info .mobile{
  float: left;
  margin-left: 14px;
}
.bawOrderDetailPage .order-delivery .address{
  font-size: 12px;
  color:#999;
}

.bawOrderDetailPage .order-list{
  overflow: hidden;
}
.bawOrderDetailPage .order-item{
  border-radius: 10px;
  background: white;
  margin: 10px 0 0;
}
.bawOrderDetailPage .shoptip{
  border-radius: 10px;
  overflow: hidden;
  background: white;
  padding:0 10px;
}
.bawOrderDetailPage .shoptip .shop-logo{
  float: left;
  line-height: 48px;
  height: 24px;
  margin: 12px 12px 12px 0;
}
.bawOrderDetailPage .shoptip .shop-name{
  float: left;
  line-height: 48px;
}
.bawOrderDetailPage .shoptip .state{
  float: right;
  line-height: 48px;
}

.bawOrderDetailPage .suborder-item-list{
  overflow: hidden;
  padding-left: 10px;
}
.bawOrderDetailPage .suborder-item{
  width:100%;
  overflow: hidden;
  padding: 20px 0;
}
.bawOrderDetailPage .suborder-item ~ .suborder-item{
  border-top:1px solid #eee;
}
.bawOrderDetailPage .suborder-item .order-img{
  width: 75px;
  height: 75px;
  object-fit: cover;
  float: left;
  border: 1px solid #eee;
  padding: 1px;
  background: white;
}
.bawOrderDetailPage .suborder-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  margin-right: 10px;
  word-break: break-all;
  height: 85px;
}
.bawOrderDetailPage .suborder-item .product-info .product-name{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 14px;
  padding-bottom: 10px;
  color:#333;
}
.bawOrderDetailPage .suborder-item .product-info .attr{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 14px;
  font-size: 12px;
  color:#999;
}
.bawOrderDetailPage .suborder-item .product-info .price{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 12px;
  margin-top: 24px;
  float: left;
}
.bawOrderDetailPage .receive-address{
  background: white;
  color:black;
  padding: 20px 25px;
  overflow: hidden;
  margin-top: 12px;
  border-radius: 10px;
}
.bawOrderDetailPage .receive-address .address-info{
  float: left;
  margin-left: 10px;
  width: 85%;
}
.bawOrderDetailPage .receive-address .address-info .name{
  font-size:16px;
  padding-right: 10px;
}
.bawOrderDetailPage .receive-address .address-info .mobile{
  font-size:14px;
  color:#aaa;
}
.bawOrderDetailPage .receive-address .address-info .address-content{
  font-size:12px;
  color:#666;
  line-height: 14px;
  height: 28px;
  margin-top: 5px;
}
.bawOrderDetailPage .receive-address .address-info .address-content .fa{
  width: 20px;
}
.bawOrderDetailPage .receive-address .goIcon{
  width:20px;
  height: 14px;
  margin-top: 29px;
}
.bawOrderDetailPage .mapIcon{
  float: left;
  width: 30px;
  line-height: 40px;
}
.bawOrderDetailPage .mapIcon img{
  width:100%;
  display: block;
  margin-top: 10px;
}
.bawOrderDetailPage .suborder-item .product-info .item-button{
  float: right;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  margin-top: 6px;
  width: 60px;
  margin: 20px 0 0 0;
  padding:0;
  border: none;
  background: #f9f9f9;
  color:#999;
  border:1px solid #999;
  border-radius: 2px;
  margin-left: 10px;
  text-align: center;
}

.bawOrderDetailPage .order-total{
  overflow: hidden;
}
.bawOrderDetailPage .total-text{
  float: right;  
  font-size: 12px;
  line-height: 48px;
}
.bawOrderDetailPage .total-text span{
  font-size: 14px;
}

.bawOrderDetailPage .order-detail{
  border-radius: 10px;
  margin: 10px 0;
  background: white;
}
.bawOrderDetailPage .order-info {
  padding: 10px 0;
}

.bawOrderDetailPage .order-info .field{
  line-height: 24px;
  font-size: 12px;
  padding-left: 10px;
  padding-right: 10px;
  overflow: hidden;
  color:#999;
}
.bawOrderDetailPage .order-info .field span{
  color:#4D4A49;
}
.bawOrderDetailPage .order-info .field .title{
  float: left;
}
.bawOrderDetailPage .order-info .field .num{
  float: right;
  font-size: 14px;
}
.bawOrderDetailPage .order-info .fa{
  font-size: 12px;
}
.bawOrderDetailPage .order-info .summary{
  line-height: 16px;
  font-size: 16px;
  text-align: right;
  margin: 10px 0 0 10px;
  padding: 15px 10px 5px;
}
.bawOrderDetailPage .order-info .summary .num{
  color:red;
}


.bawOrderDetailPage .order-operator{
  overflow: hidden;
}
.bawOrderDetailPage .order-operator .button-list{
  float: right;
  padding: 10px 10px;
}


.bawOrderDetailPage .operator{  
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background: #f9f9f9;
}
.bawOrderDetailPage .operator .button-list{
  float: right;
}
.bawOrderDetailPage .operator .button-list .button-item{
  height: 56px;
  background-color: rgb(244, 67, 54);
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/bawOrderdetail.vue